// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1NVy7","buttons":"Footer_buttons__3Oryg"};